<h5>{{ title }}</h5>
<div
  *ngIf="isLoadingStats && !isLoadingStatsErrorOccured"
  class="loading-users-stats"
></div>
<i
  class="error-stats position-relative"
  *ngIf="!isLoadingStats && isLoadingStatsErrorOccured"
  >Something went wrong.</i
>
<div class="chart">
  <ngx-charts-bar-vertical
    *ngIf="!isLoadingStats && !isLoadingStatsErrorOccured"
    [scheme]="colorScheme"
    [results]="results"
    [gradient]="gradient"
    [xAxis]="showXAxis"
    [yAxis]="showYAxis"
  >
  </ngx-charts-bar-vertical>
</div>
